import * as React from 'react';
import CareerChart from "./CareerChart";
import CTSAReportHeader from "./CTSAReportHeader";
import CompareGroupSelector from "./CompareGroupSelector";
import { transformCareerData, transformTotals } from "./CTSAReportHelper";




interface Props {
    comparisonGroup?: string[];
    availableGroup?: string[];
    changeComparisonGroup?();
    displayId?: string;
    CTSASchoolList?: {}[];
    careerData?: {}[];
    awardTotal?: { KL2: number, K01: number, K08: number, K12: number, K23: number }
}




class OngoingCareer extends React.Component<Props, {}> {
    render() {
        const { awardTotal, careerData, comparisonGroup, CTSASchoolList, displayId, changeComparisonGroup, availableGroup } = this.props;
        if (awardTotal && careerData && comparisonGroup && availableGroup) {

            return (
                <div className="tabcontents container-fluid" style={{ border: 'none' }}>

                    <CTSAReportHeader compareGroup={comparisonGroup} displayId={displayId} CTSASchoolList={CTSASchoolList} awardTotal={transformTotals(awardTotal)} />
                    <CompareGroupSelector
                        onChange={changeComparisonGroup}
                        selectedGroup={comparisonGroup}
                        awardTotal={transformTotals(awardTotal)}
                        availableGroup={availableGroup}

                    />

                    <CareerChart compareGroup={comparisonGroup} careerData={transformCareerData(careerData)} />

                    <img src={require('./CTSA_logo.jpg')} height='50px' style={{ marginTop: '20px' }} />
                </div>
            );
        } else {
            return <i className="fa fa-spinner"></i>;

        }



    }
}
export default OngoingCareer;



